import {
  css
} from 'lit';

export const FocusStyle = css`
  .focus:focus {
    outline-color: var(--lds-color-focus-outline);
    outline-offset: var(--lds-border-focus-outline-offset);
    outline-style: var(--lds-border-focus-outline-style);
    outline-width: var(--lds-border-focus-outline-width);
    box-shadow: var(--lds-shadow-focus) var(--lds-color-focus-shadow);
  }

  .focus-3px:focus {
    outline-color: var(--lds-color-focus-outline);
    outline-offset: var(--lds-border-focus-outline-offset);
    outline-style: var(--lds-border-focus-outline-style);
    outline-width: var(--lds-border-focus-outline-width);
    box-shadow: var(--lds-shadow-focus-3px) var(--lds-color-focus-shadow);
  }
`;
export default FocusStyle;
